import { createApp } from 'vue';
import App from './App.vue';
import router from '@/routes';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/multiselect/themes/default.css';
import LoaderFullScreen from '@/components/loader-fullscreen/LoaderFullScreen.vue';
import MaskedField from '@/components/masked-field/MaskedField.vue';
import 'bootstrap/dist/css/bootstrap.css';
import Vue3Lottie from 'vue3-lottie';
import MultiSelectReload from './components/multiselect-reload/MultiSelectReload.vue';
import '@/assets/js/hyper-config';

if (import.meta.env.MODE === 'development') {
  (window as any).__VUE_DEVTOOLS_GLOBAL_HOOK__ && (window as any).__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue;
}

import { pt } from 'yup-locale-pt';
import setupInterceptors from '@/interceptors/setupInterceptors';
import { store } from '@/store';

import Multiselect from '@vueform/multiselect';
import ModalConsulte from '@/components/modal/ModalConsulte.vue';
import * as yup from 'yup';
import { vMaska } from 'maska/vue';
import { QuillEditor } from '@vueup/vue-quill';
import './iodc';
import './signalr';
import '@/trace';
import Smartlook from 'smartlook-client';
import ConsulteGrid from 'consulte-framework-vue';
import VueKonva from 'vue-konva';
import { GeoTooltip } from '@/directives/geo-tooltip';

if (import.meta.env.MODE === 'production') Smartlook.init('236a58232c170dd9dc4c552f5fcb003fce0a1679', { region: 'us' });

yup.setLocale(pt);
(Multiselect as any).props.noOptionsText.default = 'Nenhuma opção cadastrada';
(Multiselect as any).props.noResultsText.default = 'Nenhum resultado encontrado';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(Vue3Lottie, { name: 'Vue3Lottie' });
app.use(VueSweetalert2);
app.directive('maska', vMaska);
app.directive('geo-tooltip', GeoTooltip);
app.use(ConsulteGrid, { store });
app.use(VueKonva);

setupInterceptors();
app.component('MultiSelect', Multiselect);
app.component('MultiSelectReload', MultiSelectReload);
app.component('ModalConsulte', ModalConsulte);
app.component('LoaderFullScreen', LoaderFullScreen);
app.component('MaskedField', MaskedField);
app.component('QuillEditor', QuillEditor);

app.mount('#app');

window.requestAnimationFrame(() => {
  const bootLoader = document.getElementById('app-boot-loader');
  if (!bootLoader) return;

  bootLoader.classList.add('app-boot-loader--hidden');
  window.setTimeout(() => bootLoader.remove(), 180);
});

import 'consulte-framework-vue/style.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@/assets/css/consulte-geo-hyper.css';
import '@/assets/css/consulte-geo-overrides.css';
